<template>
  <v-footer height="auto" width="100%" class="mt-4 mb-4">
    <v-layout column class="background">
      <template v-if="isDynamicFooter">
        <v-layout row wrap class="px-4">
          <!-- Branding -->
          <v-flex xs12 md3 wrap>
            <v-layout column>
              <v-flex xs12>
                <div class="pb-3">
                  <img
                    width="150"
                    height="45"
                    class="branding-image"
                    :src="company.logo_url"
                    alt="Logo"
                  />
                </div>
                <div class="mb-4">
                  {{ company.custom_properties.footer_configurations.data.description[currentLocale] }}
                </div>
                <div>
                  <span>Email us :- <b>contact@netfest.org</b></span>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Quick Links -->
          <v-flex xs12 md3 wrap>
            <v-layout column class="" v-if="company.custom_properties.footer_configurations.configurations.quick_links">
              <v-flex xs12 class="padding-left">
                <div class="custom-title font-weight-bold mb-7 pb-4">
                  <b>{{ $t("app.footer.links.quick_links") }}</b>
                </div>
                
                <div class="menu-links">
                  <template v-for="quick_link in company.custom_properties.footer_configurations.data.QuickLinks">
                    <v-btn
                      class="px-0 mx-0 secondary--text left-align-btn"
                      flat
                      text
                      min-width="0"
                      :target="quick_link.target" 
                      :key="quick_link.link"
                      @click="openPageLink(quick_link)"
                    >
                      {{ quick_link.title[currentLocale] }}
                    </v-btn>
                  </template>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Legals -->
          <v-flex xs12 md3 wrap>
            <v-layout column class="" v-if="company.custom_properties.footer_configurations.configurations.legal_links">
              <v-flex xs12>
                <div class="custom-title font-weight-bold mb-7 pb-4">
                  <b>{{ $t("app.footer.links.legals") }}</b>
                </div>
    
                <div class="menu-links">
                  <template v-for="legal_link in company.custom_properties.footer_configurations.data.LegalLinks" >
                    <v-btn
                      class="px-0 mx-0 secondary--text left-align-btn"
                      flat
                      text
                      min-width="0"
                      :target="legal_link.target"
                      :key="legal_link.link"
                      @click="openPageLink(legal_link)"
                    >
                      {{ legal_link.title[currentLocale] }}
                    </v-btn>
                  </template>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Follow Links -->
          <v-flex xs12 md3 wrap>
            <v-layout column wrap class="" v-if="company.custom_properties.footer_configurations.configurations.social_media_links">
              <v-flex xs12 sm12 md3 align-self-start>
                            <div class="custom-title mb-4 pl-1 ">
                  <b>{{ $t("app.footer.links.follow_us") }}</b>
                </div>
                <v-layout row wrap class="pr-4">
                  <v-flex
                    v-for="(social_link, key) in company.custom_properties.footer_configurations.data.SocalMediaLinks"
                    :key="key"
                    xs-auto
                    class="d-flex justify-center align-center"
                    style="width: auto; padding: 1px"
                  >
                    <v-btn
                      v-if="social_link.link"
                      class="mr-2 mb-2 custom-btn"
                      icon
                      @click="openPageLink(social_link)"
                    >
                      <template v-if="social_link.type === 'twitter'">
                          <v-img
                            :src="twitterIconSrc"
                            alt="Twitter"
                            max-width="20"
                            max-height="20"
                            contain
                          />
                      </template>
                      <!-- Default icon for other social media links -->
                      <v-icon v-else>{{ 'mdi-'+social_link.type }}</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md3 align-self-start>
                <NewsletterForm v-if="showNewsLetter" />
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- If SA enabled ORG branding & there is footer msg -->
        </v-layout>
      </template>
      <template v-else>
        <v-layout
          justify-space-between
          row
          xs12
          md="row"
          wrap
          align-start
          class="px-4 py-0"
        >
          <!-- Branding -->
          <v-flex
            xs12
            md4
            sm12
            align-self-start
            class="text-body-2 branding-text"
          >
            <div class="pb-3">
              <img
                width="150"
                height="45"
                class="branding-image"
                :src="company.logo_url"
                alt="Logo"
              />
            </div>
            <div class="mb-4">
              {{ company.title }} is the next-gen platform for Festivals’ lovers, not just an on-line
              platform but a vision. It was born from the idea of bringing the kind of
              cinema presented in film Festivals to a wider audience.
            </div>
            <div>
              <span>Email us :- <b>contact@netfest.org</b></span>
            </div>
          </v-flex>
          <!-- Quick Links -->
          <v-layout column class="left-align-layout">
            <v-flex xs12>
              <div class="custom-title font-weight-bold mb-7 pb-4">
                <b>{{ $t("app.footer.links.quick_links") }}</b>
              </div>
  
              <div class="menu-links">
                <v-btn
                  class="px-0 mx-0 secondary--text left-align-btn"
                  flat
                  text
                  min-width="0"
                  target="_blank"
                  @click="_getRouteUrl('screeners.archive')"
                >
                  {{ $t("footer.menu.archive") }}
                </v-btn>
  
                <v-btn
                  v-if="companyId == DEFINES.FIREPLACE_AD_COMPANY_ID"
                  class="px-0 mx-0 secondary--text left-align-btn"
                  flat
                  text
                  min-width="0"
                  @click="_getRouteUrl('user.dashboard')"
                >
                  {{ $t("rms.toolbar.consumer.header.menu.dashboard") }}
                </v-btn>
  
                <v-btn
                  v-if="company.slug != 'netfest'"
                  class="px-0 mx-0 secondary--text left-align-btn"
                  flat
                  text
                  min-width="0"
                  target="_blank"
                  @click="DEFINES.HOMEPAGE_LINK"
                >
                  {{ $t("watch.title") }}
                </v-btn>

                <!-- <template v-for="(menu, i) in menus">
                  <v-btn
                    v-if="
                      !menu.title &&
                      def_pages[menu.slug] &&
                      menu.slug !== 'privacy' &&
                      menu.slug !== 'terms'
                    "
                    class="px-0 mx-0 secondary--text left-align-btn"
                    flat
                    text
                    min-width="0"
                    :key="i + menu.text"
                    @click="_getRouteUrl(menu.link)"
                    target="_blank"
                  >
                    {{ menu.text }}
                  </v-btn>
  
                  <v-btn
                    v-if="menu.title && menu.slug !== 'privacy' && menu.slug !== 'terms'"
                    class="px-0 mx-0 secondary--text left-align-btn"
                    flat
                    text
                    min-width="0"
                    :key="i + menu.slug"
                    @click="
                      menu.isExternal
                        ? menu.link
                        : _getRouteUrl('company.page', { slug: menu.slug[currentLocale] })
                    "
                    target="_blank"
                  >
                    {{ menu.title[currentLocale] }}
                  </v-btn>
                </template> -->
                <v-btn 
                  class="px-0 mx-0 secondary--text left-align-btn" 
                  flat
                  text
                  min-width="0"
                  @click="_getRouteUrl('company.about')" 
                  target="_blank" 
                  color="primary">
                  {{ $t("page.about") }}
                  </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <!-- Legals -->
          <v-layout column class="left-align-layout">
            <v-flex xs12>
              <div class="custom-title font-weight-bold mb-7 pb-4">
                <b>{{ $t("app.footer.links.legals") }}</b>
              </div>
  
              <div class="menu-links">
                <v-btn
                  v-if="companyId == DEFINES.FIREPLACE_AD_COMPANY_ID"
                  class="px-0 mx-0 secondary--text left-align-btn"
                  flat
                  text
                  min-width="0"
                  @click="_getRouteUrl('user.dashboard')"
                >
                  {{ $t("rms.toolbar.consumer.header.menu.dashboard") }}
                </v-btn>

                <v-btn
                  class="px-0 mx-0 secondary--text left-align-btn"
                  flat
                  text
                  min-width="0"
                  @click="_getRouteUrl('company.terms')"
                >
                  {{ $t("page.terms") }}
                </v-btn>
  
                <!-- <template v-for="(menu, i) in menus">
                  <v-btn
                    v-if="
                      !menu.title &&
                      def_pages[menu.slug] &&
                      menu.slug !== 'past-event' &&
                      menu.slug !== 'watch' &&
                      menu.slug !== 'about'
                    "
                    class="px-0 mx-0 secondary--text left-align-btn"
                    flat
                    text
                    min-width="0"
                    :key="i + menu.text"
                    @click="_getRouteUrl(menu.link)"
                    target="_blank"
                  >
                    {{ menu.text }}
                  </v-btn>
  
                  <v-btn
                    v-if="
                      menu.title &&
                      menu.slug !== 'past-event' &&
                      menu.slug !== 'watch' &&
                      menu.slug !== 'about'
                    "
                    class="px-0 mx-0 secondary--text left-align-btn"
                    flat
                    text
                    min-width="0"
                    :key="i + menu.slug"
                    @click="
                      menu.isExternal
                        ? menu.link
                        : _getRouteUrl('company.page', { slug: menu.slug[currentLocale] })
                    "
                    target="_blank"
                  >
                    {{ menu.title[currentLocale] }}
                  </v-btn>
                </template> -->
              </div>
            </v-flex>
          </v-layout>
          <!-- Follow Links -->
          <v-layout column wrap class="left-align-layout">
            <v-flex xs12 sm12 md3 align-self-start>
                          <div class="custom-title mb-4 pl-1 ">
                <b>{{ $t("app.footer.links.follow_us") }}</b>
              </div>
              <v-layout row wrap class="pr-4">
                <v-flex
                  v-for="(link, key) in socialMediaLinks"
                  :key="key"
                  xs-auto
                  class="d-flex justify-center align-center"
                  style="width: auto; padding: 1px"
                >
                  <v-btn
                    v-if="link.url"
                    class="mr-2 mb-2 custom-btn"
                    icon
                    @click="goToSocialMediaPage(link.url)"
                  >
                    <!-- Check if the icon is for Twitter -->
                    <template v-if="link.icon === 'mdi-twitter'">
                      <v-img
                        :src="twitterIconSrc"
                        alt="Twitter"
                        max-width="20"
                        max-height="20"
                        contain
                      />
                    </template>
                    <!-- Default icon for other social media links -->
                    <v-icon v-else>{{ link.icon }}</v-icon>
                  </v-btn> 
                </v-flex>
              </v-layout>              
            </v-flex>
            <v-flex xs12 sm12 md3 align-self-start>
              <NewsletterForm v-if="showNewsLetter" />
            </v-flex>
          </v-layout>
          <!-- If SA enabled ORG branding & there is footer msg -->
        </v-layout>
      </template>
      
      <v-divider class=""></v-divider>
      <!-- Copyrights -->
      <v-layout justify-center align-left column class="fill-height mb-5 pl-4">
        <v-flex xs12>
          <div
            v-if="
              company.show_company_branding &&
              company.custom_properties.powered_by_message
            "
          >
            {{ company.custom_properties.powered_by_message }}
          </div>
          <div v-else>
            &copy;{{ moment().format("YYYY") }} —
            {{ $t("screener.powered_by.text") }}
            <a target="_blank" href="https://netfest.org/" class="text-decoration-none">
              <strong class="primary--text">{{ $appInfo.appName }}</strong>
            </a>
            <small class="pl-4">Version: {{ DEFINES.APP_VERSION }}</small>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-footer>
</template>
<script>
import i18n from "@/i18n";
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import NewsletterForm from "@/components/NewsletterForm";

export default {
  name: "CompanyFooter",
  props: {
    isNetfestVod: Boolean,
    referrerUrl: String
  },
  components: {
    NewsletterForm,
  },
  data() {
    return {
      socialMediaLinks: {
        twitter: { url: "https://x.com/netfest_org", icon: "mdi-twitter" },
        youtube: {
          url: "https://www.youtube.com/channel/UCxWIu6TaZTubSMjb0Rfj0DA",
          icon: "mdi-youtube",
        },
        facebook: { url: "https://www.facebook.com/netfest.org", icon: "mdi-facebook" },
        instagram: {
          url: "https://www.instagram.com/netfest_org/",
          icon: "mdi-instagram",
        },
      },
    };
  },
  mounted() {
    this.getApiData();
  },

  computed: {
    ...mapState({
      list: (state) => state.page.list,
      company: (state) => state.company.company,
      referrerUrl: (state) => state.app.referrerURL,
    }),
    ...mapGetters("company", {
      companyId: "getCurrentCompanyId",
    }),
    ...mapGetters("app", {
      isNetfestVod: "isNetfestVod"
    }),
    def_pages() {
      if (
        !this.company ||
        !this.company.custom_properties ||
        !this.company.custom_properties.hasOwnProperty("def_pages")
      ) {
        return {
          about: true,
          terms: true,
          privacy: true,
        };
      }
      return this.company.custom_properties.def_pages;
    },
    menus() {
      var default_menus = [
        {
          slug: "about",
          text: i18n.t("page.about"),
          link: "company.about",
        },
        {
          slug: "privacy",
          text: i18n.t("page.privacy"),
          link: "company.privacy",
        },
        {
          slug: "terms",
          text: i18n.t("page.terms"),
          link: "company.terms",
        },
      ];
      return this.list && this.list.length
        ? default_menus.concat(this.list)
        : default_menus;
    },
    showNewsLetter: function () {
      return (
        this.company &&
        this.company.custom_properties.mcApiKey &&
        this.company.custom_properties.mcListId
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    netfestVodUrl() {
      return window.location.protocol + '//' + this.referrerUrl;
    },
    isDynamicFooter(){
      let isDynamic = false
      if ('footer_configurations' in this.company.custom_properties) {
        isDynamic = this.company.custom_properties.footer_configurations.enable_feature
      }

      return isDynamic
    },
    currentLocale(){
      return this.$i18n.locale;
    },
    isDarkTheme() {
      return this.$store.getters["app/darkMode"];
    },
    twitterIconSrc() {
      return this.isDarkTheme
        ? require("@/assets/twitter-white.png")
        : require("@/assets/twitter-black.png");
    }
  },

  watch: {
    companyId() {
      this.getApiData();
    },
    list() {
      this.processData();
    },
  },

  methods: {
    async getApiData() {
      if (!this.companyId) {
        return;
      }
      try {
        var response = await this.$store.dispatch("page/list");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    processData() {
      if (
        this.company &&
        this.company.custom_properties &&
        this.company.custom_properties.hasOwnProperty("def_pages")
      ) {
        this.def_pages = this.company.custom_properties.def_pages;
      }
    },
    _getRouteUrl(routeName, params = {}) {
      console.log("Route Name: ", routeName)
      if (!routeName) return;
      
      if(['screeners.archive'].includes(routeName)){
        if (this.isNetfestVod) {
      return window.open(this.referrerUrl, '_self');
    }
      }
      
      const route = this.$router.resolve({ name: routeName, params: params });
      return window.open(route.href) 
    },
    goToSocialMediaPage(url) {
      window.open(url, "_blank");
    },
    openPageLink(urlDetail) {
      try {
        const linkUrl = new URL(urlDetail.link, window.location.origin);
        const isInternal = linkUrl.origin === window.location.origin;

        if (isInternal) {
          // Internal link → use Vue Router
          if (urlDetail.target === '_self') {
            this.$router.push({ path: linkUrl.pathname }).catch(() => {});
          } else {
            const resolved = this.$router.resolve(linkUrl.pathname);
            window.open(resolved.href, '_blank');
          }
        } else {
          // External link → use native navigation
          if (urlDetail.target === '_self') {
            window.location.href = urlDetail.link;
          } else {
            window.open(urlDetail.link, '_blank');
          }
        }
      } catch (e) {
        console.error('Invalid URL:', urlDetail.link, e);
      }
    }
  },
};
</script>
<style>
.text-decoration-none {
  text-decoration: none;
}
.left-align-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  width: fit-content !important;
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.left-align-layout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content !important;
  padding-top: 0;
  padding: auto;
  padding-left: 40px;
  margin: 0;
}

.left-align-btn {
  justify-content: flex-start !important;
  text-align: left !important;
  display: flex;
  width: fit-content;
  min-width: 0 !important;
}
.footer-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
}

.custom-btn {
  border-radius: 50%;
  border: thin solid currentColor;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}

.custom-btn:hover {
  background-color: var(--v-primary-base);
  color: white !important;
}
.custom-title {
  font-size: 20px !important;
}

@media screen and (max-width: 768px) {
  .v-footer .v-flex img {
    width: 108px !important;
    height: auto !important;
    margin-left: 0 !important;
    margin-right: auto !important;
  }

  .v-footer .v-flex {
    width: auto !important;
    max-width: 108px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    justify-content: flex-start !important;
  }

  .v-footer .v-layout {
    flex-direction: column !important;
    justify-content: flex-start;
  }

  .v-footer .left-align-layout {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  /* Force these sections to be side by side */
  .v-footer .left-align-layout:nth-child(2),
  .v-footer .left-align-layout:nth-child(3),
  .v-footer .left-align-layout:nth-child(4),
  .v-footer .left-align-layout:nth-child(5) {
    display: flex !important;
    flex-wrap: wrap !important;  /* Ensures they don’t break */
    justify-content: space-between !important;
    align-items: flex-start !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: auto !important;
  }

  .v-footer .left-align-layout:nth-child(2),
  .v-footer .left-align-layout:nth-child(3) {
    width: 48% !important; /* Ensures they fit in the same row */
  }

  .v-footer .left-align-layout:nth-child(4),
  .v-footer .left-align-layout:nth-child(5) {
    width: 48% !important; /* Ensures they fit in the same row */
  }

  .v-footer .branding-text {
    width: 100% !important;
    text-align: left !important;
  }

  .v-footer .branding-image {
    width: 128px !important;
    height: 39px !important;
    margin-left: 0 !important;
    margin-right: auto !important;
    display: block;
  }
  .padding-left {
    padding-left: 0px !important;
  }
}

@media screen and (min-width: 768px) {
  .padding-left {
    padding-left: 20px !important;
  }
}

</style>
